import type { TFunction } from 'i18next'
import type { WorkspaceKind } from 'shared'

interface SummarySource {
  kind?: WorkspaceKind | null
  industry: string | null
  stage: string | null
  revenue_range?: string | null
}

/**
 * The one line under a company's name: its industry and what places it, which
 * is the stage for a startup and the revenue band for a company (a company has
 * no stage to show, even if one was saved before it changed kind).
 */
export function workspaceSummary(workspace: SummarySource, t: TFunction): string {
  const placing =
    workspace.kind === 'company'
      ? workspace.revenue_range
        ? t(`workspaces.revenueRanges.${workspace.revenue_range}`, workspace.revenue_range)
        : null
      : workspace.stage

  return [workspace.industry, placing].filter(Boolean).join(' · ')
}
